"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clickHandler = void 0;
exports["default"] = Cta;
exports.tertiaryStyleMap = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = require("@JohnLewisPartnership/jl-design-system/dist/elements/button/Button");
var _Link = _interopRequireDefault(require("@JohnLewisPartnership/jl-design-system/dist/elements/link/Link"));
var _IconCta = _interopRequireDefault(require("./IconCta/IconCta"));
var _useEnhancedHref = _interopRequireDefault(require("../../hooks/useEnhancedHref"));
var _imageWrapper = _interopRequireDefault(require("../imageWrapper/imageWrapper"));
var _ctaModule = _interopRequireDefault(require("./cta.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var clickHandler = exports.clickHandler = function clickHandler(event, enhancedHref) {
  if (enhancedHref !== null && enhancedHref !== void 0 && enhancedHref.startsWith('#')) {
    var _enhancedHref$split$;
    event.preventDefault();
    var anchor = document.getElementById(enhancedHref === null || enhancedHref === void 0 || (_enhancedHref$split$ = enhancedHref.split('?')[0]) === null || _enhancedHref$split$ === void 0 ? void 0 : _enhancedHref$split$.slice(1));
    anchor === null || anchor === void 0 || anchor.scrollIntoView();
  }
};
var tertiaryStyleMap = exports.tertiaryStyleMap = function tertiaryStyleMap(style) {
  switch (style) {
    case 'Tertiary - clear dark':
      return 'clear-dark';
    case 'Tertiary - clear white':
      return 'clear-white';
    case 'Tertiary - tonal light':
      return 'tonal-light';
    case 'Tertiary - tonal dark':
      return 'tonal-dark';
    case 'Tertiary - filled light':
      return 'filled-light';
    case 'Tertiary - filled dark':
      return 'filled-dark';
    default:
      return 'clear-light';
  }
};
function Cta(props) {
  var _props$logo, _props$logo2;
  var eventType = props.eventType || 'ctaClick';
  var enhancedHref = (0, _useEnhancedHref["default"])(props.target);
  switch (props.type) {
    case 'primary':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: (0, _classnames["default"])(_ctaModule["default"].ctaContainer, props.className),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.PrimaryButton, {
          "data-testid": "primary-button",
          tag: "a",
          href: enhancedHref,
          inline: props.inline,
          inverted: props.style === 'Primary - variant 2',
          sale: props.style === 'Primary - variant 3',
          target: props.newTab ? '_blank' : null,
          rel: props.newTab ? 'noopener noreferrer' : null,
          "data-event": eventType,
          "data-component": props.componentName,
          "data-section": props.section,
          "data-location": props.linkLocation,
          disabled: props.disabled,
          onClick: function onClick(event) {
            return clickHandler(event, enhancedHref);
          },
          children: !props.children ? props.label : props.children
        })
      });
    case 'secondary':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: (0, _classnames["default"])(_ctaModule["default"].ctaContainer, props.className),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.SecondaryButton, {
          "data-testid": "secondary-button",
          tag: "a",
          href: enhancedHref,
          inline: props.inline,
          inverted: props.style === 'Secondary - variant 2',
          target: props.newTab ? '_blank' : null,
          rel: props.newTab ? 'noopener noreferrer' : null,
          "data-event": eventType,
          "data-component": props.componentName,
          "data-section": props.section,
          "data-location": props.linkLocation,
          disabled: props.disabled,
          children: !props.children ? props.label : props.children
        })
      });
    case 'tertiary':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: (0, _classnames["default"])(_ctaModule["default"].ctaContainer, props.className),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.TertiaryButton, {
          small: true,
          "data-testid": "tertiary-button",
          tag: "a",
          href: enhancedHref,
          IconComponent: props.icon,
          variant: tertiaryStyleMap(props.style),
          inline: props.inline,
          target: props.newTab ? '_blank' : null,
          rel: props.newTab ? 'noopener noreferrer' : null,
          "data-event": eventType,
          "data-component": props.componentName,
          "data-section": props.section,
          "data-location": props.linkLocation,
          disabled: props.disabled,
          children: !props.children ? props.label : props.children
        })
      });
    case 'underlined':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: (0, _classnames["default"])(_ctaModule["default"].ctaContainer, props.className),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.UnderlinedButton, {
          className: _ctaModule["default"].underlinedCta,
          "data-testid": "underlined-button",
          tag: "a",
          href: enhancedHref,
          inline: props.inline,
          inverted: props.style === 'UnderlinedV2 - variant 2',
          target: props.newTab ? '_blank' : null,
          rel: props.newTab ? 'noopener noreferrer' : null,
          "data-event": eventType,
          "data-component": props.componentName,
          "data-section": props.section,
          "data-location": props.linkLocation,
          disabled: props.disabled,
          children: !props.children ? props.label : props.children
        })
      });
    case 'link':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: (0, _classnames["default"])(_ctaModule["default"].ctaContainer, props.className),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link["default"], {
          className: _ctaModule["default"].linkCta,
          "data-testid": "link-button",
          to: enhancedHref,
          external: true,
          target: props.newTab ? '_blank' : null,
          "data-event": eventType,
          "data-component": props.componentName,
          "data-section": props.section,
          "data-location": props.linkLocation,
          children: !props.children ? props.label : props.children
        })
      });
    case 'logo':
      return (_props$logo = props.logo) !== null && _props$logo !== void 0 && _props$logo.sourceMobile ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _ctaModule["default"].logoCta,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
          "data-testid": "logo-button",
          href: enhancedHref,
          target: props.newTab ? '_blank' : undefined,
          rel: props.newTab ? 'noopener noreferrer' : undefined,
          "data-event": eventType,
          "data-component": props.componentName,
          "data-section": props.section,
          "data-location": props.linkLocation,
          "aria-label": ((_props$logo2 = props.logo) === null || _props$logo2 === void 0 ? void 0 : _props$logo2.altText) || 'Logo link',
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_imageWrapper["default"], {
            altText: props.logo.altText,
            mobile: props.logo.sourceMobile,
            tablet: props.logo.sourceTablet || props.logo.sourceDesktop,
            desktop: props.logo.sourceDesktop
          })
        })
      }) : null;
    case 'icon':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconCta["default"], {
        label: props.label,
        href: enhancedHref,
        newTab: props.newTab,
        dataTracking: {
          eventType: eventType,
          componentName: props.componentName,
          section: props.section,
          linkLocation: props.linkLocation
        }
      });
  }
}